module.exports = __webpack_public_path__ + "img/default_avatar.29d83676.png";